const InstaIcon = () => {
  return (
    <>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_10_463)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 12.501C18.1638 12.501 19.9178 14.2279 19.9178 16.3582C19.9178 18.488 18.1637 20.2149 16 20.2149C13.8363 20.2149 12.0822 18.488 12.0822 16.3582C12.0822 14.2279 13.8363 12.501 16 12.501ZM16 10.9586C12.9708 10.9586 10.5151 13.376 10.5151 16.3582C10.5151 19.3399 12.9708 21.7577 16 21.7577C19.0292 21.7577 21.4849 19.3399 21.4849 16.3582C21.4849 13.376 19.0293 10.9586 16 10.9586ZM21.6543 9.66064C21.3502 9.66541 21.0542 9.75994 20.8037 9.93236C20.5531 10.1048 20.3591 10.3474 20.2461 10.6297C20.133 10.9121 20.1059 11.2215 20.1681 11.5192C20.2304 11.8169 20.3792 12.0896 20.5959 12.303C20.8127 12.5164 21.0877 12.6609 21.3863 12.7185C21.6849 12.7761 21.9939 12.7441 22.2745 12.6266C22.555 12.5091 22.7946 12.3114 22.963 12.0582C23.1315 11.8049 23.2214 11.5076 23.2214 11.2034C23.2181 10.791 23.0512 10.3968 22.7573 10.1075C22.4634 9.8182 22.0666 9.65746 21.6543 9.66064ZM12.1714 7.98157H19.8286C22.3196 7.98157 24.339 9.96954 24.339 12.4215V20.2944C24.339 22.7468 22.3196 24.7343 19.8286 24.7343H12.1714C9.68038 24.7343 7.66098 22.7468 7.66098 20.2944V12.4215C7.66098 9.96954 9.68035 7.98157 12.1714 7.98157ZM11.4492 6.44604C8.48831 6.44604 6.08799 8.80917 6.08799 11.7238V20.9921C6.08799 23.9072 8.48828 26.2698 11.4492 26.2698H20.5508C23.5117 26.2698 25.912 23.9072 25.912 20.9921V11.7238C25.912 8.80914 23.5117 6.44604 20.5508 6.44604H11.4492ZM16 0.870483C24.5535 0.870483 31.4875 7.80424 31.4875 16.3582C31.4875 24.9116 24.5535 31.8454 16 31.8454C7.44648 31.8454 0.512512 24.9116 0.512512 16.3582C0.512512 7.80426 7.44648 0.870483 16 0.870483Z"
            fill="#1F2937"
          />
        </g>
        <defs>
          <clipPath id="clip0_10_463">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export default InstaIcon
